import { post, get } from '../../../../services/request';

//-------------------Raw Exam Data - start----------------//
// Get all raw exam data
export const getAllRawExamData = (payload) => {
    return post(`ExamData/GetAllRawExamDataWithPagination`, payload);
};

//refresh raw exam data
export const refreshRawExamData = (payload) => {
    // Accepts a single object: { fromDate, toDate, userId }
    const { fromDate, toDate, userId } = payload || {};
   
    if (!fromDate || !toDate) throw new Error('fromDate and toDate are required for refreshRawExamData');
    return post(`ExamData/ReCalculateExamDataDetailsByDate?FromDate=${fromDate}&ToDate=${toDate}&CreatedBy=${userId}`);
};
//-------------------Raw Exam Data - end----------------//